<template>
    <div class="dispensing-item-preview">
        <div class="action mb-2">
            <span>{{ t('patients::dispensing.form.title.add_number_of_days') }}</span>
        </div>
        <v-form ref="form" v-model="form" :disabled="readOnlyRules" class="number-of-days-form">
            <b-input
                to-mutate="patients::dispensingForm.max_allowed_dispensing_days"
                :label="t('patients::dispensing.form.label.max_allowed_dispensing_days')"
                :disabled="!canAddDays"
                type="number"
                :is-number="true"
                :hint="' '"
                class="pills large"
                @input="maxDaysToDispenseChanged = true"
            ></b-input>
            <b-input
                to-mutate="patients::dispensingForm.accumulated_dispensing_days"
                :label="t('patients::dispensing.form.label.accumulated_dispensing_days')"
                type="number"
                :is-number="true"
                :hint="' '"
                :append-icon="`${accumulatedDaysToDispenseChanged ? 'mdi-content-save-outline' : ''}`"
                :class="`${accumulatedDaysToDispenseChanged ? 'extend pills large' : 'pills large'}`"
                @click:append="accumulatedDialog = true"
                @input="accumulatedDaysToDispenseChanged = true"
            ></b-input>
            <b-confirm
                :text="`${maxDaysToDispense} ${t('patients::dispensing.dispense.title.text')} `"
                :title="t('patients::dispensing.dispense.title')"
                @true="dispensDay"
            >
                <template #button="{ on }">
                    <v-btn
                        color="primary"
                        small
                        rounded
                        outlined
                        :disabled="readOnlyRules || !dispensingPermitted"
                        v-on="on"
                    >
                        {{ t('patients::button.dispense') }}
                    </v-btn>
                </template>
            </b-confirm>
        </v-form>
        <v-dialog v-model="accumulatedDialog" width="400">
            <v-card>
                <v-card-title class="headline" primary-title>
                    {{ t('patients::dispensing.dispense.title') }}</v-card-title
                >
                <v-card-text>
                    {{ `${t('patients::dispensing.dispense.cumulated.title.text')} ${accumulatedDispensingDays}.` }}
                </v-card-text>
                <v-card-actions>
                    <v-btn rounded color="primary" text @click="resetdAccumulatedDay">{{
                        t('default::confirmation.no')
                    }}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn rounded color="primary" @click="dispensAccumulatedDay">{{
                        t('default::confirmation.yes')
                    }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    props: {
        readOnlyRules: {
            type: Boolean,
            required: true,
            default: false,
        },
    },
    data() {
        return {
            form: false,
            accumulatedDialog: false,
            accumulatedDaysToDispenseChanged: false,
            maxDaysToDispenseChanged: false,
            validationRules: {
                schedule_restart_period: [(v) => !!v || t('users::validation.field.required')],
            },
        };
    },
    computed: {
        dispensing() {
            return this.$store.state.patients.patient.dispensing;
        },
        dispensingForm() {
            return this.$store.state.patients.dispensingForm;
        },
        dispensingPermitted() {
            return (
                !this.isHcpDispensers ||
                (this.isHcpDispensers && this.$store.state.patients.patient?.is_allowed_to_dispense)
            );
        },
        maxDaysToDispense() {
            return this.$store.state.patients.dispensingForm.max_allowed_dispensing_days;
        },
        accumulatedDispensingDays() {
            return this.$store.state.patients.dispensingForm.accumulated_dispensing_days;
        },
        patientId() {
            return this.$store.state.patients.patient.id;
        },
        dispensingScheduleOptions() {
            var week = this.dispensing.schedule_frequency;
            return this.$store.state.patients.dispensingScheduleOptions.map((x) => {
                return { text: (x.text = `${t('patients::schedule_frequency.' + week)} ${x.text}`), value: x.value };
            });
        },
        canAddDays() {
            return _.isEmpty(this.maxDaysToDispense) || this.maxDaysToDispense > 0;
        },
        isHcpDispensers() {
            return (
                this.$store.state.user.profile &&
                (this.$store.state.user.profile.role === 'hcp-pharmacy-dispensers' ||
                    this.$store.state.user.profile.role === 'hcp-analyser-dispenser')
            );
        },
    },
    watch: {
        dispensing() {
            if (!this.maxDaysToDispenseChanged && !this.maxDaysToDispenseChanged) {
                this.setDaysForm();
            }
        },
    },
    created() {
        this.$store.dispatch('patients/loadDispensingScheduleOptions');
    },
    mounted() {
        this.setDaysForm();
    },
    methods: {
        setDaysForm() {
            const state_max_allowed_dispensing_days = this.dispensing.max_allowed_dispensing_days;
            const state_accumulated_dispensing_days = this.dispensing.accumulated_dispensing_days;
            const form_max_allowed_dispensing_days = this.dispensingForm.max_allowed_dispensing_days;
            const form_accumulated_dispensing_days = this.dispensingForm.accumulated_dispensing_days;
            if (state_max_allowed_dispensing_days !== form_max_allowed_dispensing_days) {
                this.$store.dispatch('patients/updateProperty', {
                    property: 'dispensingForm.max_allowed_dispensing_days',
                    value: this.dispensing.max_allowed_dispensing_days,
                });
            }
            if (state_accumulated_dispensing_days !== form_accumulated_dispensing_days) {
                this.$store.dispatch('patients/updateProperty', {
                    property: 'dispensingForm.accumulated_dispensing_days',
                    value: this.dispensing.accumulated_dispensing_days,
                });
            }
        },
        dispensAccumulatedDay() {
            this.$store.dispatch('patients/setDispensingLoading', true);
            return axios
                .post(
                    route('api.v1.patients.dispensing-days.accumulated', {
                        patient: this.patientId,
                    }),
                    {
                        days: this.dispensingForm.accumulated_dispensing_days,
                    }
                )
                .then(() => {
                    this.$store.dispatch('patients/resetDispensingForm');
                    this.$store.dispatch('patients/resetErrorMessages');
                })
                .catch((error) => {
                    this.$store.dispatch('patients/setDispensingLoading', false);
                    if (error.response && error.response.status === 422) {
                        error.response.data.errors = error.response.data.errors.map((x) => ({
                            field: 'accumulated_dispensing_days',
                            errors: x.errors,
                        }));

                        this.$store.dispatch('patients/setErrorMessages', {
                            isDispensingForm: true,
                            errors: error.response.data.errors,
                        });
                    } else {
                        this.$root.notify('error', error.response.data.error);
                    }
                })
                .finally(() => {
                    // this.$store.dispatch('patients/setDispensingLoading', false);
                });
        },
        resetdAccumulatedDay() {
            this.accumulatedDialog = false;
            this.$store.dispatch('patients/updateProperty', {
                property: 'dispensingForm.accumulated_dispensing_days',
                value: this.dispensing.accumulated_dispensing_days,
            });
        },
        dispensDay() {
            // this.$store.dispatch('patients/setDispensingLoading', true);
            return axios
                .post(
                    route('api.v1.patients.dispensing-days.dispensed', {
                        patient: this.patientId,
                    }),
                    {
                        days: this.dispensingForm.max_allowed_dispensing_days,
                    }
                )
                .then(() => {
                    this.$store.dispatch('patients/resetDispensingForm');
                    this.$store.dispatch('patients/resetErrorMessages');
                })
                .catch((error) => {
                    if (error.response && error.response.status === 422) {
                        error.response.data.errors = error.response.data.errors.map((x) => ({
                            field: 'max_allowed_dispensing_days',
                            errors: x.errors,
                        }));

                        this.$store.dispatch('patients/setErrorMessages', {
                            isDispensingForm: true,
                            errors: error.response.data.errors,
                        });
                    } else {
                        this.$root.notify('error', error.response.data.error);
                    }
                })
                .finally(() => {
                    // this.$store.dispatch('patients/setDispensingLoading', false);
                });
        },
    },
};
</script>
